const casePaidTaskStyle = {
  pdfGenerator: {
    marginBottom: "2rem",
  },
};

export default casePaidTaskStyle;
